import React, { ReactNode } from "react";

interface Props {
    children: ReactNode;
}

const LoginWrapper: React.FC<Props> = ({
    children
}) => {
    return (
        <div className="login">{children}</div>
    )
}

export default LoginWrapper;